import React from 'react';
import PropTypes from 'prop-types';

function IconHistory({ color = '#C2C2C2', size = 24, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.3318 8.02218V12.0006L15.6471 13.9897M7.69031 10.0114H4.375M4.375 10.0114V6.69605M4.375 10.0114C5.3928 8.76232 6.19842 7.83072 7.17395 6.84275C8.18764 5.8291 9.47755 5.13663 10.8825 4.85188C12.2875 4.56713 13.7452 4.70272 15.0736 5.24171C16.402 5.7807 17.542 6.69918 18.3514 7.8824C19.1607 9.06563 19.6035 10.4611 19.6242 11.8945C19.645 13.3279 19.2429 14.7356 18.4682 15.9418C17.6935 17.148 16.5806 18.0992 15.2684 18.6764C13.9562 19.2537 12.503 19.4315 11.0904 19.1876C9.67772 18.9437 8.36827 18.2889 7.32563 17.3051" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconHistory.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconHistory;
